import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const Hero = () => {
  const benefits = [
    "Fix broken or unreliable tracking in Google Tag Manager",
    "Implement GA4 or Matomo without the stress",
    "Track conversions, scrolls, forms, and funnels with clarity",
    "Clean up messy tag setups and streamline your DataLayer",
    "Gain data you can trust to make decisions with confidence"
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-gradient-to-br from-white to-accent/30 py-20 md:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center animate-fade-in">
          <h1 className="mb-6 leading-tight">
            Get Accurate, Actionable Analytics Data —{" "}
            <span className="text-primary">Without the Headaches</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-12 text-text-secondary max-w-3xl mx-auto leading-relaxed">
            We help digital agencies, e-commerce brands, and marketing teams implement and fix 
            Google Tag Manager, GA4, and Matomo — so your data is reliable, your tracking is complete, 
            and your reporting just works.
          </p>

          <div className="grid md:grid-cols-2 gap-4 mb-12 max-w-4xl mx-auto">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="flex items-start gap-3 text-left animate-slide-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex-shrink-0 mt-1">
                  <Check className="h-5 w-5 text-success" />
                </div>
                <span className="text-text-primary font-medium">{benefit}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg" 
              onClick={scrollToContact}
              className="bg-primary hover:bg-primary/90 text-white px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              Book a Free Discovery Call
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <p className="text-sm text-text-secondary">
              Free 15-minute strategy session • No obligations
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
